import React, { useMemo } from "react";
import DetailsTable from "./DetailsTable";
import DetailsSectionLabel from "./DetailsSectionLabel";

export default function TaxInfoTab({ data }) {
  if (data.Year === new Date().getFullYear()) {
    data.Assessments = [];
    data.Exemptions = [];
    data.TaxRates = [];
  }
  const assessmentColumns = useMemo(
    () => [
      {
        label: "Category",
        key: "Category",
        minWidth: "150",
      },
      { label: "Land/Lot", key: "LandLot" },
      { label: "Improvement", key: "Improvement" },
      { label: "Farm Land", key: "FarmLand" },
      { label: "Farm Building", key: "FarmBuilding" },
      { label: "Mineral", key: "Mineral" },
      { label: "Total", key: "Total" },
    ],
    []
  );
  const excemptionColumns = useMemo(
    () => [
      {
        label: "Exemption",
        key: "ExemptionDesc",
        minWidth: "150",
      },
      { label: "Active Date", key: "ActiveDate", minWidth: "150" },
      { label: "Amount", key: "Amount" },
    ],
    []
  );

  const taxRateColumns = useMemo(
    () => [
      { label: "Tax District", key: "District", minWidth: "150" },
      { label: "Tax Rate", key: "Rate" },
      { label: "Tax Amount", key: "Amount" },
    ],
    []
  );

  return (
    <>
      <DetailsSectionLabel label="ASSESSMENTS" isFirst={true} />
      <DetailsTable rows={data.Assessments} columns={assessmentColumns} />

      <DetailsSectionLabel label="EXEMPTIONS" />
      <DetailsTable rows={data.Exemptions} columns={excemptionColumns} />

      <DetailsSectionLabel label="TAX RATES" />
      <DetailsTable rows={data.TaxRates} columns={taxRateColumns} />
    </>
  );
}
